<rs-web-error-screen>
  <h2 class="title">{{ 'user_edit_error_title' | translate }}</h2>
  @for (message of errorMsgKeys$ | async; track message) {
    <p>{{ message | translate }}</p>
  }
</rs-web-error-screen>
